import { render, staticRenderFns } from "./other-info.vue?vue&type=template&id=b2072d7a&scoped=true&lang=pug&"
import script from "./other-info.vue?vue&type=script&lang=js&"
export * from "./other-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2072d7a",
  null
  
)

export default component.exports